import { Button as AntButton } from 'antd';
import type { ButtonProps as AntButtonProps } from 'antd';
import type React from 'react';

import { withAuthGuard } from '../../auth';
import type { AuthProps } from '../../auth';

export type ButtonProps = AntButtonProps & AuthProps;

/**
 * Themed, auth-gated pass-through of antd's `Button`. No behavior change for
 * callers that don't pass `auth` — colors come from the app's `ConfigProvider`
 * theme (Phase 2 cascade), not from anything this wrapper adds.
 */
export const Button = withAuthGuard(AntButton, {
    defaultFallback: 'disable',
}) as unknown as React.ForwardRefExoticComponent<
    ButtonProps & React.RefAttributes<HTMLButtonElement>
>;
